import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('confirm-dialog')
export class ConfirmDialog extends LitElement {
  createRenderRoot() {
    return this;
  }

  @property({ type: Boolean })
  open = false;

  @property({ type: String })
  title = 'Confirm';

  @property({ type: String })
  message = 'Are you sure?';

  @property({ type: String })
  confirmText = 'Confirm';

  @property({ type: String })
  cancelText = 'Cancel';

  @property({ type: Boolean })
  destructive = false;

  @property({ type: Boolean })
  loading = false;

  private handleConfirm() {
    this.dispatchEvent(new CustomEvent('confirm'));
  }

  private handleCancel() {
    this.dispatchEvent(new CustomEvent('cancel'));
  }

  private handleBackdropClick(e: Event) {
    if (e.target === e.currentTarget) {
      this.handleCancel();
    }
  }

  private handleKeyDown(e: KeyboardEvent) {
    if (e.key === 'Escape' && !this.loading) {
      this.handleCancel();
    }
  }

  connectedCallback() {
    super.connectedCallback();
    window.addEventListener('keydown', this.handleKeyDown.bind(this));
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    window.removeEventListener('keydown', this.handleKeyDown.bind(this));
  }

  render() {
    if (!this.open) return nothing;

    return html`
      <div
        class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 animate-fade-in"
        @click=${this.handleBackdropClick}
      >
        <div class="card bg-base-100 shadow-2xl w-full max-w-sm mx-4 animate-slide-up">
          <div class="card-body">
            <h3 class="card-title text-lg">${this.title}</h3>
            <p class="text-base-content/80 py-2">${this.message}</p>
            <div class="card-actions justify-end mt-4">
              <button
                class="btn btn-ghost"
                @click=${this.handleCancel}
                ?disabled=${this.loading}
              >
                ${this.cancelText}
              </button>
              <button
                class="btn ${this.destructive ? 'btn-error' : 'btn-primary'}"
                @click=${this.handleConfirm}
                ?disabled=${this.loading}
              >
                ${this.loading
                  ? html`<span class="loading loading-spinner loading-sm"></span>`
                  : this.confirmText}
              </button>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
